const deglawyFaturesPath = '/deglawy/featured';
export const getDeglawyFatures = (status = 'all') => `${deglawyFaturesPath}?status=${status}`;
export const getDeglawyFaturedById = (id: number) => `${deglawyFaturesPath}/${id}?`;
export const createDeglawyFatured = `${deglawyFaturesPath}`;
export const updateDeglawyFatured = (id: number) => `${deglawyFaturesPath}/${id}`;
export const updateDeglawyFaturedStatus = (id: number) => `${deglawyFaturesPath}/${id}/activation`;
